import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import CommentOutlineIcon from '../../../../../../Icons/CommentOutline';
import { getDeviationUrl, getDeviationResourceType, } from '../../../../../_helpers';
import OverlayControl from '../../../../../Helper/OverlayControl';
import BiLink from '../../../../../../biLogger/Components/BiLink';
import { BiEventType } from '../../../../../../biLogger/constants';
import { VisuallyHidden } from '../../../../../../a11y';
import { useOverlayContext } from '../../OverlayContext';
import s from '../OverlayIcons.scss';
var CommentControl = function (_a) {
    var deviation = _a.deviation, className = _a.className, iconClassName = _a.iconClassName, statClassName = _a.statClassName, showFlipped = _a.showFlipped, size = _a.size;
    var t = useTranslation().t;
    var showStats = useOverlayContext(deviation).showStats;
    return (React.createElement(BiLink, { className: classnames(s['icon-button'], className), href: getDeviationUrl(deviation) + "#comments", "aria-label": t('deviationview.overlay.a11y.comment'), biData: {
            evid: BiEventType.THUMB_CLICK_COMMENT,
            typeid: getDeviationResourceType(deviation),
            creatorid: deviation.author ? deviation.author.useridUuid : undefined,
            itemid: deviation.deviationId,
        } },
        React.createElement(OverlayControl, { showStats: showStats, statClassName: statClassName, stat: deviation.stats && deviation.stats.comments, showFlipped: showFlipped, extraStatContent: React.createElement(VisuallyHidden, null, t('deviationview.overlay.a11y.commentStat')) },
            React.createElement(CommentOutlineIcon, { size: size, withPadding: false, disableDefaultColors: true, className: classnames(s['icon'], iconClassName) }))));
};
CommentControl.displayName = 'CommentControl';
export default CommentControl;
//# sourceMappingURL=CommentControl.js.map